import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    onApprove: () => void;
}

const GPSConsentModal: React.FC<Props> = ({ onApprove }) => {
    const { t } = useTranslation();
    const [isInteracting, setIsInteracting] = useState(false);

    const handleApprove = () => {
        setIsInteracting(true);
        onApprove();

        setTimeout(() => setIsInteracting(false), 1000);
    };

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                padding: 20,
            }}
            role="dialog"
            aria-modal="true"
        >
            <div
                style={{
                    maxWidth: 500,
                    width: "100%",
                    background: "white",
                    padding: "30px",
                    borderRadius: 12,
                    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                    textAlign: "center"
                }}
            >
                <h2 style={{ marginTop: 0, fontSize: "1.5rem", color: "#333" }}>
                    {t('GPS Location needed')}
                </h2>

                <p style={{ color: "#666", fontSize: "1rem", lineHeight: "1.5" }}>
                    {t('GPS Functionality')}
                    <br /><br />
                    <strong>{t('GPS Location failed')}</strong>
                </p>

                <div style={{ marginTop: 25 }}>
                    <button
                        onClick={handleApprove}
                        disabled={isInteracting}
                        style={{
                            padding: "12px 24px",
                            borderRadius: 6,
                            border: "none",
                            cursor: isInteracting ? "default" : "pointer",
                            background: "#007bff",
                            color: "#fff",
                            fontSize: "1rem",
                            fontWeight: "bold",
                            width: "100%",
                            opacity: isInteracting ? 0.7 : 1
                        }}
                    >
                        {isInteracting ? t('Wait') : t('Close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GPSConsentModal;